var INPUTRULES = {
  email:/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
  mobile:/^(((13[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(14[0-9]{1}))+\d{8})$/,
  id:/^[1-9][0-9]{5}(19[0-9]{2}|200[0-9]|2010)(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[0-9]{3}[0-9xX]$/,
  realname:/^[\u4e00-\u9fa5]{2,9}$/,
  enterprise:/^[\u4e00-\u9fa5]{3,51}/,
  zipcode:/^[0-9]{6}$/,
  fixedTel:/^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/,
  password: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/,
  qrcode: /^[a-zA-Z0-9]{4}$/
};

var serverInfo = {
  protocol: window.location.protocol,
  host: window.location.host,
  port: window.location.port,
  path: window.location.pathname,

};

export default {
  INPUTRULES : {
    email:/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
    mobile:/^(((13[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(14[0-9]{1}))+\d{8})$/,
    id:/^[1-9][0-9]{5}(19[0-9]{2}|200[0-9]|2010)(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[0-9]{3}[0-9xX]$/,
    realname:/^[\u4e00-\u9fa5]{2,9}$/,
    enterprise:/^[\u4e00-\u9fa5]{3,51}/,
    zipcode:/^[0-9]{6}$/,
    fixedTel:/^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/,
    password: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/,
    qrcode: /^[a-zA-Z0-9]{4}$/
  },
  serverInfo : {
    protocol: window.location.protocol,
    host: window.location.host,
    port: window.location.port,
    path: window.location.pathname,
  },
  EVIDENCE_TYPE: [
    '录屏取证',
    '快照取证',
    '移动端录屏取证',
    '过程取证'
  ],
  PACKAGE_CONFIG: {
    '30001': '快照存证',
    '30002': '录屏存证'
  }
}
// 假如现在是开发环境地址，上生产了这些地址和接口怎么换？？
// 怎么打生产包？？？
// 假如生产地址 http://128.3.3.3:8080
// 测试地址 http://111.5.5.5:8088
// 从测试上生产那个location 里面的字段挨个改是通过哪段东西自动实现的，



// WEBPACK FOOTER //
// ./src/lib/const.js